import React from 'react';
import { AppPageHeader } from './app/AppPage';

/**
 * Legacy page header API, now drawn by the shared app header so every signed-in
 * screen opens the same way. Crumbs accept either `url` or `path`.
 */
const PageHeader = ({ title, breadcrumbs = [], actionButton = null, description = null }) => {
  const crumbs = breadcrumbs.length
    ? [
        { label: 'Dashboard', to: '/dashboard' },
        ...breadcrumbs.map((crumb, index) => ({
          label: crumb.label,
          to: index === breadcrumbs.length - 1 ? undefined : crumb.url || crumb.path,
        })),
      ]
    : undefined;
  return <AppPageHeader title={title} description={description || undefined} actions={actionButton || undefined} crumbs={crumbs} />;
};

export default PageHeader;
